import React, { Component } from "react";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Tooltip from "@material-ui/core/Tooltip";
import { connect } from "formik";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Consumer as WorkflowConsumer } from "./context";

const styles = theme => ({
  icon: {
    marginLeft: theme.spacing(2)
  }
});

const WorkflowSideNavItem = withStyles(styles, {
  name: "LcWorkflowSideNavItem"
})(
  ({
    classes,
    label,
    tooltip,
    secondary,
    icon: Icon,
    disabled,
    selected,
    onClick,
    avatar
  }) => {
    /* eslint-disable react/jsx-indent */
    const itemIcon = Icon ? (
      <ListItemIcon classes={{ root: classes.icon }}>
        {avatar
          ? Icon && (
              <Avatar>
                <Icon />
              </Avatar>
            )
          : Icon && <Icon />}
      </ListItemIcon>
    ) : (
      <div className={classes.icon} />
    );
    /* eslint-enable react/jsx-indent */

    const item = (
      <ListItem
        button
        disabled={disabled}
        disableGutters
        selected={selected}
        onClick={onClick}
      >
        {itemIcon}
        <Hidden smDown implementation="css">
          <ListItemText primary={label} secondary={secondary} />
        </Hidden>
      </ListItem>
    );

    if (tooltip)
      return (
        <Tooltip title={tooltip} placement="right">
          {item}
        </Tooltip>
      );

    return item;
  }
);

class WorkflowSideNav extends Component {
  getProps = (
    {
      formik: { isValid, submitForm },
      history: { push },
      location: { pathname = "***NONE***" }
    } = this.props
  ) => ({
    isValid,
    submitForm,
    push,
    pathname
  });

  shouldComponentUpdate = nextProps => {
    const next = this.getProps(nextProps);
    const orig = this.getProps();
    return (
      next.isValid !== orig.isValid ||
      next.submitForm !== orig.submitForm ||
      next.pathname !== orig.pathname
    );
  };

  render = () => {
    const { isValid, submitForm, pathname } = this.getProps(this.props);
    let j = 0;
    return (
      <WorkflowConsumer>
        {({ steps, stepInfo, getActiveStep, getLink, goTo }) => {
          const activeStep = getActiveStep();

          let lastIdx = steps.length - 1;

          return steps.map((step, idx) => {
            const substeps = (Array.isArray(step) ? step : [step]).filter(
              item => !(stepInfo[item] || {}).hideNav
            );

            if (substeps.length === 0) return null;

            return (
              <React.Fragment key={j++}>
                <List key={j++}>
                  {substeps.map(substep => {
                    const info = stepInfo[substep] || {};

                    let disabled = info.disabled;

                    // dont disable current step
                    if (info === activeStep) disabled = false;

                    // dont disable next step if current is valid
                    const nextStep =
                      activeStep !== undefined && stepInfo[activeStep.next];
                    if (nextStep === info && isValid) disabled = false;

                    // dont disable step if step is valid
                    //if (info && info.form && info.form.isInitialValid)
                    //disabled = false;

                    //if (!info.disabled)
                    //disabled = false;

                    const link = getLink(substep, true);
                    const onClick =
                      nextStep === info
                        ? submitForm
                        : () => goTo(substep, this.props.formik);

                    return (
                      <WorkflowSideNavItem
                        key={j++}
                        label={substep}
                        {...info}
                        disabled={disabled}
                        onClick={onClick}
                        selected={
                          link === pathname ||
                          info.links
                            .map(item => getLink(item, true))
                            .includes(pathname)
                        }
                      />
                    );
                  })}
                </List>
                {idx !== lastIdx ? <Divider /> : null}
              </React.Fragment>
            );
          });
        }}
      </WorkflowConsumer>
    );
  };
}

export default withRouter(connect(WorkflowSideNav));
